// extracted by mini-css-extract-plugin
export default {"form":"ResponseModal_form__s+fgH","phone":"ResponseModal_phone__Hn11s","btn":"ResponseModal_btn__-XYYN","cover":"ResponseModal_cover__ZrkB1"};